<template>
  <div class="team-item">
    <div class="leader-info">
      <ym-avatar class="user-avatar"
                 :avatar="leader.avatar"
                 :name="leader.name"
                 size="small"
      />
      <div class="user-name ym-line-ellipsis">{{ leader.name }}</div>
    </div>
    <div class="team-container">
      <div class="team-info">
        还差<span class="remain-member">{{ remain }}人</span>成团
        <div class="remain-time">
          剩余{{timerData.hours}}:{{timerData.minutes}}:{{timerData.seconds}}
        </div>
      </div>
      <ym-button class="show-team-btn"
                 size="mini"
                 type="danger"
                 @click="handleShowTeamDetail(id)"
      >
        去参团
      </ym-button>
    </div>
  </div>
</template>

<script>
  import { Button } from '@ymba/ym-ui';
  import CountDown from '@/utils/count-down';
  import Avatar from '@/components/Avatar';

  export default {
    name: 'GroupBuyBlockTeamListItem',
    components: {
      'ym-button': Button,
      'ym-avatar': Avatar,
    },
    data() {
      return {
        timerData: {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        },
      };
    },
    props: {
      id: {
        type: Number,
        required: true,
      },
      leader: {
        type: Object,
        required: true,
      },
      remain: {
        type: Number,
        required: true,
      },
      start: {
        type: Number,
        required: true,
        default: 0,
      },
      end: {
        type: Number,
        required: true,
        default: 0,
      },
      groupBuyUrl: {
        type: String,
      },
    },
    methods: {
      handleShowTeamDetail(id) {
        const route = { name: 'GroupBuyTeamDetail', params: { id } };
        this.$router.push(route);
      },
      initCountDown() {
        new CountDown({
          startTime: this.start,
          endTime: this.end,
          render: (data) => {
            this.timerData = data;
          },
        });
      },
    },
    created() {
      this.initCountDown();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .team-item {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .leader-info {
    overflow: hidden;
    display: flex;
    flex: 1;
    align-items: center;
    margin-right: @size-extra-small + @size-extra-small / 2;
  }

  .user-avatar {
    flex-shrink: 0;
    margin-right: @size-extra-small + @size-extra-small / 2;
  }

  .user-name {
    overflow: hidden;
    flex: 1;
    font-size: @font-size-small;
    line-height: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .team-container {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .show-team-btn {
    flex-shrink: 0;
    margin-left: @size-base;
  }

  .team-info {
    line-height: 1;
    font-size: @font-size-small;
  }

  .remain-member {
    display: inline-block;
    margin: 0 @size-extra-small / 2;
    font-weight: @font-weight-bold;
    color: @color-highlight;
  }

  .remain-time {
    margin-top: @size-extra-small;
    color: @color-text-light;
    font-size: @font-size-extra-extra-small;
    text-align: right;
  }
</style>
